import { action } from 'typesafe-actions'
import { IAcceptCookies, CookiesTypes } from './types'

export const changeCookies = (payload: IAcceptCookies) =>
  action(CookiesTypes.CHANGE_ACCEPT, payload)

export const changeUnderstood = (payload: boolean) => action(CookiesTypes.UNDERSTOOD, payload)
